export const FIELD_OFFICER_ROLE_ENUM = {
  FIELD_OFFICER: "FIELD_OFFICER",
  FIELD_OFFICER_HARVEST: "FIELD_OFFICER_HARVEST",
  FIELD_OFFICER_AGRONOMIST: "FIELD_OFFICER_AGRONOMIST",
  FIELD_OFFICER_COORDINATOR: "FIELD_OFFICER_COORDINATOR",
  FIELD_OFFICER_QA: "FIELD_OFFICER_QA",
  REGIONAL_HEAD: "REGIONAL_HEAD",
  FIELD_MANAGER: "FIELD_MANAGER",
  FIELD_SUPERVISOR: "FIELD_SUPERVISOR",
  HARVEST_SPV: "HARVEST_SPV",
  DRONE_PILOT_SPV: "DRONE_PILOT_SPV"
}

export const FIELD_OFFICER_ROLE_STRING = {
  AGRONOMIST_SPV: "Agronomist & Drone Spv"
}

export const ORDER_STATUS_ENUM = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  RESCHEDULED: "RESCHEDULED",
  REJECTED: "REJECTED",
  CANCELED: "CANCELED",
  CONFIRMED_FO: "CONFIRMED_FO",
  OVERDUE: "OVERDUE",
  CONFIRMED_ERP: "CONFIRMED_ERP",
  SPK_CREATED: "SPK_CREATED"
}

export const ORDER_STATUS_PLANTING_ENUM = {
  PRE_PLANTING: "PRE_PLANTING",
  PASCA_PLANTING: "PASCA_PLANTING",
  CLEARING_AREA: "LAND_CLEARING"
}

export const ROUTING_STATUS = {
  SCHEDULE_STRING: {
    PENDING: "Pending",
    RESCHEDULE: "Rescheduled",
    APPROVE: "Approved",
    REJECT: "Rejected",
    ALL: "all"
  },
  SPRAYING_PASCA_PLANTING_STRING: {
    PENDING: "pending",
    RESCHEDULED: "rescheduled",
    APPROVED: "scheduled",
    REJECT: "rejected",
    CANCEL: "canceled",
    DONE: "done",
    OVERDUE: "overdue"
  },
  MAC_SPRAYING_STRING: {
    PENDING: "pending",
    RESCHEDULED: "rescheduled",
    APPROVED: "approved",
    REJECT: "rejected",
    CANCEL: "canceled",
    DONE: "done",
    OVERDUE: "overdue"
  },
  STATUS_STRING: {
    PENDING: "pending",
    ACTIVE: "active",
    REJECT: "reject",
    REJECTED: "rejected",
    INACTIVE: "inactive"
  },
  STATUS_ENUM: {
    PENDING: "PENDING",
    ACTIVE: "ACTIVE",
    REJECT: "REJECT",
    REJECTED: "REJECTED",
    INACTIVE: "INACTIVE",
    SUBMITTED: "SUBMITTED",
    COMPLETED: "COMPLETED"
  },
  CERTIFICATION_STATUS_STRING: {
    PENDING: "pending",
    SUBMITTED: "submitted",
    APPROVED: "approved",
    REJECTED: "rejected"
  },
  ACTIVITY_REPORT: {
    READY_SEND_FINANCE: "ready-send-finance",
    SENDING_FINANCE: "sending-finance",
    NEED_BA: "need-ba",
    NO_BILL: "no-bill"
  },
  BLOCK_STATUS_STRING: {
    ACTIVE: "active",
    HISTORY: "history"
  },
  PLANTING_SEASON_STATUS_STRING: {
    NOT_PAID: "not_paid",
    PARTIALLY_PAID: "partially_paid",
    PAID: "paid"
  }
}

export const ACTIVITY_STATUS_ENUM = {
  WAITING: "WAITING",
  NEED_BA: "NEED_BA",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED"
}

export const ACTIVITY_METHODE_ENUM = {
  MANUAL: "MANUAL",
  AUTOMATIC: "AUTOMATIC",
  USING_TOOL: "USING_TOOL"
}

export const PLANT_TYPE_ENUM = {
  PADI: "PADI",
  JAGUNG: "JAGUNG"
}

export const HARVEST_TYPE_ENUM = {
  PRODUCTION: "PRODUCTION",
  FREE_MARKET: "FREE_MARKET"
}

export const TEMPLATE_TYPE_ENUM = {
  FULL: "FULL",
  DEFAULT: "DEFAULT"
}

export const DATE_TYPE_ENUM = {
  ISO_DATE_ID: "dd MMMM yyyy",
  ISO_DATETIME_ID: "dd MMMM yyyy HH:mm:ss",
  ISO_TIME_ID: "HH:mm:ss",
  ISO_DATE_EURO: "yyyy-MM-dd",
  ISO_DATETIME_STRAP: "dd-MM-yyyy HH:mm:ss",
  ISO_DATE_STRAP: "dd-MM-yyyy",
  ISO_TIME_STRAP: "HH:mm:ss",
  ISO_TIME_STRAP_SHORT: "HH:mm",
  DDMMYYYY: "ddMMyyyy",
  ISO_DATE_ABBREVIATED: "dd MMM yyyy"
}

export const GENDER_ENUM = {
  MALE: "MALE",
  FEMALE: "FEMALE"
}

export const MACHINE_OWNER_TYPE_ENUM = {
  MAXXI_TANI: "MAXXI_TANI",
  MITRA: "MITRA",
  THIRD_PARTY: "THIRD_PARTY",
  FARMER: "FARMER",
  OTHER_MITRA: "OTHER_MITRA",
  OTHER_FARMER: "OTHER_FARMER",
  OTHER_VENDOR: "OTHER_VENDOR"
}

export const AREA_STATUS = {
  LEAD_AREA: "LEAD_AREA"
}

export const BUYER_TYPE_ENUM = {
  FACTORY: "FACTORY",
  FARMER: "FARMER",
  INDIVIDUAL: "INDIVIDUAL"
}

export const BUYER_TYPE_STRING = {
  FACTORY: "Pabrik",
  FARMER: "Petani",
  INDIVIDUAL: "Perseorangan"
}

export const PLANT_TYPE_STRING = {
  PADDY: "padi",
  CORN: "jagung",
  PROD_CORN: "jagung produksi"
}

export const ACTIVE_TAB_ENUM = {
  REPORT: "REPORT",
  SUBMISSION: "SUBMISSION",
  MASTER: "MASTER",
  SETTING: "SETTING",
  MAC: "MAC",
  ORDER: "ORDER",
  AREA: "AREA",
  FO: "FO",
  FARMER: "FARMER",
  MITRA: "MITRA"
}

export const REASON = {
  DISASTER: "5e0adb30-9116-4dab-a942-93391d67084d",
  PEST: "468ee20a-777b-47db-8e5f-d49e33c13458",
  OTHER_PARENT: "9691f70b-a789-4013-a49e-66cd311355a6",
  OTHER_DISASTER: "bb976b3f-0529-46e3-ac74-6485d5595512",
  OTHER_PLANTING_SEASON: "a80c0654-baa4-11f0-ab27-16e732ee873d",
}

export const STATUS_VARIANT_CONSTANT = {
  COMPLETED: "completed",
  WARNING: "warning",
  DANGER: "danger"
}

export const FARMER_GENDER = {
  MEN: "LAKI_LAKI",
  WOMAN: "PEREMPUAN"
}

export const MITRA_TYPE = {
  EDUCATIONAL_INSTITUTIONS: "EDUCATIONAL_INSTITUTIONS",
  GOVERNMENT_AGENCIES: "GOVERNMENT_AGENCIES",
  PRIVATE_COMPANIES: "PRIVATE_COMPANIES",
  INDIVIDUAL: "INDIVIDUAL",
  RETAILER_MAI: "RETAILER_MAI"
}

export const MITRA_ACTIVE_CONTRACT_STATUS_ENUM = {
  ALL_CONTRACTS: "ALL_CONTRACTS",
  EXPIRING_SOON: "EXPIRING_SOON",
  EXPIRES_TODAY: "EXPIRES_TODAY",
  EXPIRED: "EXPIRED"
}

export const MITRA_ACTIVE_CONTRACT_STATUS_STRING = {
  ALL_CONTRACTS: "Semua",
  EXPIRING_SOON: "Kontrak Akan Berakhir",
  EXPIRES_TODAY: "Kontrak Berakhir",
  EXPIRED: "Kontrak Terlewat"
}

export const GENDER_TYPE = {
  LAKI_LAKI: "LAKI-LAKI",
  PEREMPUAN: "PEREMPUAN"
}

export const GENDER_REQUEST_ENUM = {
  MALE: "LAKI_LAKI",
  FEMALE: "PEREMPUAN"
}

export const MITRA_DOCUMENT = {
  KTP: "KTP",
  SWAFOTO: "SWAFOTO",
  BUSINESS_DOCUMENT: "BUSINESS_DOCUMENT",
  OTHER_IMAGE: "OTHER_IMAGE"
}

export const AREA_SALES_ORDER_TAB = {
  SO: "so",
  SPK: "spk"
}

export const AREA_STATUS_ORDER_ENUM = {
  CONFIRMED_FO: "CONFIRMED_FO",
  CONFIRMED_ERP: "CONFIRMED_ERP",
  NEED_BA: "NEED_BA",
  WAITING: "WAITING",
  APPROVED: "APPROVED"
}

export const AREA_STATUS_STRING = {
  ...ROUTING_STATUS.STATUS_STRING,
  REGISTERED: "teregistrasi",
  LEAD: "lead",
  UNASSIGN: "unassign",
  MAP: "map"
}

export const PLANTING_STATUS_ENUM = {
  ...ROUTING_STATUS.STATUS_ENUM,
  REGISTERED: "REGISTERED"
}

export const FARMER_DOCUMENT = {
  KTP: "KTP",
  SELFIE: "SELFIE",
  FILE_EXCEL: "FILE_EXCEL"
}

export const REASON_FAILURE_ENUM = {
  PEST_ATTACK: "PEST_ATTACK",
  FLOODING: "FLOODING",
  OTHER: "OTHER",
  DRYNESS: "DRYNESS",
  ACID: "ACID",
  PH: "PH"
}

export const FO_MITRA_ASSIGN_MODE_STRING = {
  SINGLE: "single",
  BULK: "bulk"
}

export const POP_UP_TYPE_STRING = {
  EMPTY: "empty",
  BERHASIL: "berhasil",
  GAGAL: "gagal",
  NONIMAGE: "nonImage"
}

export const MASTER_DATA_CATEGORY_ITEM_STRING = {
  FERTILIZER: "fertilizer"
}

export const AREA_ACTIVITY_STRING = {
  APPROVED: "approved",
  MANUAL: "manual",
  WAITING: "waiting",
  REGISTERED: "teregistrasi"
}

export const ACCOUNT_STATUS_STRING = {
  ACTIVE: "Active",
  INACTIVE: "Inactive"
}

export const INSPECTION_STATUS_ENUM = {
  PASS: "PASS",
  NOT_PASS: "NOT_PASS",
  PARTIAL_PASS: "PARTIAL_PASS",
  LAND_CLEARING: "LAND_CLEARING"
}

export const INSPECTION_STATUS_STRING = {
  PASS: "Lulus",
  NOT_PASS: "Tidak Lulus",
  PARTIAL_PASS: "Lulus Sebagian",
  LAND_CLEARING: "Bongkar"
}

export const ACTIVITY_TYPE_ENUM = {
  PRELIMINARY: "PRELIMINARY",
  VEGETATIVE: "VEGETATIVE",
  FLOWERING: "FLOWERING",
  RIPE: "RIPE",
  HARVEST: "HARVEST",
  SPRAYING_PREPLANTING: "SPRAYING_PREPLANTING",
  PLANTING: "PLANTING",
  SEEDLING: "SEEDLING"
}

export const ACTIVITY_TYPE_STRING = {
  PRELIMINARY: "Pendahuluan",
  VEGETATIVE: "Vegetatif",
  FLOWERING: "Berbunga",
  RIPE: "Masak",
  HARVEST: "Panen"
}

export const KPI_GOAL_SETTING_TAB = {
  THIS_YEAR: "year",
  LOG: "log",
  HISTORY: "history"
}
export const RESULT_STATUS_ENUM = {
  CONTROLLED: "CONTROLLED",
  UNCONTROLLED: "UNCONTROLLED"
}

export const ACTION_INIT_TYPE = {
  MITRA: {
    DEACTIVATE_MITRA: "DEACTIVATE_MITRA",
    UPLOAD: "UPLOAD",
    UPDATE_IMAGE: "UPDATE_IMAGE",
    SYNC_ERP: "SYNC_ERP"
  }
}

export const MITRA_STATUS = {
  ACTIVE: "Aktif",
  WAITING: "Sedang Menunggu",
  REJECT: "Ditolak",
  INACTIVE: "Tidak Aktif"
}

export const UI_STATUS = {
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  VERIFIED: "VERIFIED"
}

export const AREA_UPDATE_STATUS = {
  REJECTED: "REJECTED",
  APPROVE: "APPROVE"
}

export const AREA_REGISTERED_ENUM = {
  ...ROUTING_STATUS.STATUS_STRING,
  ALL: "all",
  REGISTERED: "teregistrasi",
  AREA_KUR: "area-kur",
  AREA: "area",
  MT_ACTIVE: "active-mt",
  MT_COMPLETED: "completed-mt",
  LAND_NEW: "new-land"
}

export const LABEL_AREA_TAB_STATUS_ENUM = {
  active_mt: "AktifMT",
  completed_mt: "SelesaiMT",
  new_land: "LahanBaru"
}

export const AREA_REGISTERED_ACTIVE_TAB_ENUM = {
  NOT_PLANTED_YET: "not-planted-yet",
  ACTIVE_PLANTING: "active-planting",
  UPCOMING_HARVEST: "upcoming-harvest",
  HARVEST_PERIOD: "harvest-period",
  HARVESTED: "harvested",
  ANOMALY: "anomaly"
}

export const SUB_MENU_REGISTERED = {
  NOT_PLANTED_YET: "Belum Tanam",
  ACTIVE_PLANTING: "Aktif Tanam",
  UPCOMING_HARVEST: "Akan Panen",
  HARVEST_PERIOD: "Masa Panen",
  HARVESTED: "Sudah Panen",
  ANOMALY: "Anomali"
}


export const AREA_STATUS_ENUM = {
  ...ROUTING_STATUS.STATUS_ENUM,
  LEAD_AREA: "LEAD_AREA",
  UNASSIGNED: "UNASSIGNED"
}

export const FARMER_ACTIVATION_ENUM = {
  ...ROUTING_STATUS.STATUS_ENUM
}

export const FO_STATUS_ENUM = {
  ...ROUTING_STATUS.STATUS_ENUM
}

export const FO_UPLOAD_ENUM = {
  AVATAR: "AVATAR"
}

export const ACCOUNT_STATUS_ENUM = {
  ...ROUTING_STATUS.STATUS_ENUM
}

export const SEED_METHOD_ENUM = {
  SEEDLING_MANUAL: "SEEDLING_MANUAL"
}

export const SCHEDULING_STATUS_ENUM = {
  OTHER: "OTHER",
}

export const BULK_CANCEL_SCHEDULING_BUTTON = {
  OK: "OK",
  REDIRECT: "REDIRECT",
}

export const UNIT_STRING = {
  HA: "ha",
  HST: "hst",
  M2: "m2",
}

export const PAYMENT_STATUS_ENUM = {
  PAID: "PAID",
  NOT_PAID: "NOT_PAID",
  PARTIALLY_PAID: "PARTIALLY_PAID",
  NON_BILL: "NON_BILL"
}

export const PAYMENT_STATUS_STRING = {
  PAID: "Lunas",
  NOT_PAID: "Belum Bayar",
  PARTIALLY_PAID: "Bayar Parsial",
  NON_BILL: "Non Tagihan"
}

export const BLOCK_ACTIVITY_TYPE_ENUM = {
  PASS: "PASS",
  NOT_PASS: "NOT_PASS",
  PARTIAL_PASS: "PARTIAL_PASS"
}

export const SORT_ORDER_STRING = {
  ASC: "asc",
  DESC: "desc"
}


export const BASE_STATUS_ENUM = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
}

export const BASE_TYPE_ENUM = {
  BASECAMP: "BASECAMP",
  SHOWROOM: "SHOWROOM",
}

export const BASE_DETAIL_TAB_STRING = {
  DETAIL: "detail",
  OPS_TEAM: "ops-team",
  TEAM_DRONE: "team-drone",
  LOG: "log"
}

export const WAREHOUSE_TYPE_ENUM = {
  BASE: "BASE",
  MOBILE: "MOBILE"
}

export const OWNER_TYPE_ENUM = {
  MAXXI_TANI: "MAXXI_TANI",
  FARMER: "FARMER"
}

export const REMOVE_FARMER_REASON_ENUM = {
  OTHER: "LAINNYA"
}

export const LABELING_CONST = {
  FREEZE: "FREEZE",
  BLACKLIST: "BLACKLIST",
  ACTIVE: "ACTIVE",
  FROZEN: "FROZEN",
  BLACKLISTED: "BLACKLISTED",
  UNFREEZE: "UNFREEZE"
}

// Some endpoints return "FREEZE", others "FROZEN"; accept both
export const isFrozen = (status) =>
  status === LABELING_CONST.FROZEN || status === LABELING_CONST.FREEZE

export const DOCUMENT_TYPE_ENUM = {
  TAX_ID: "TAX_ID",
  CONTRACT: "CONTRACT",
}

export const FIELD_OFFICER_LIST_ACTION_ENUM = {
  ASSIGN_MITRA: "ASSIGN_MITRA",
}